const appConfig = {
	theme_color: 'hsl(131, 41%, 47%)',
	features: {
		loginAfterRegistration: false,
		loginAfterResetPassword: true,
		wishlist: true,
		productReviews: false,
		filterProducts: true,
		orderProducts: true,
		searchProducts: true,
		newsletter: true,
		mergeCarts: false,
	},
	brand_name: 'suwe-Kosmetik',
	url_dev_api: 'https://localhost',
	currency: 'EUR',
	currencySign: '€',
	tax: 19,
	shipping: 600,
	free_shipping: 7500,
	shipping_const: 600,
	lowest_price_before_discount_days: 30,
	default_payment_method: 'advancePayment',
	default_stripe_payment_method_type: 'card',
	payments: {
		stripe: {
			return_url: '$1/$2/pay/success?payment_id=$3&order_id=$4',
		},
		paypal: {
			return_url: '$1/$2/pay/success?payment_id=$3&order_id=$4',
			cancel_url: '$1/$2/pay/cancel?payment_id=$3&order_id=$4',
		},
	},
	legal: {
		company: 'suwe-Kosmetik',
		street: 'Breiter Weg 2',
		country: 'Deutschland',
		state: 'Niedersachsen',
		country_2_digits: 'D',
		postcode: '38518',
		city: 'Gifhorn',
		manager: 'Sabine Suwe-Witt',
		phone: '00491796677618',
		phone_label: '+49-(0) 179 6677618',
		email: 'info@suwe-kosmetik.de',
		web: 'suwe-kosmetik.de',
		bank: 'Targobank Düsseldorf',
		iban: 'DE58 3002 0900 5360 6674 62',
		bic: 'CMCIDEDDXXX',
		tax_id: 'DE355730663',
		email_retouren: 'retouren@suwe-kosmetik.de',
	},
	seo: {
		title: 'suwe-Kosmetik',
		description: 'suwe-Kosmetik Ecommerce',
		openGraph: {
			title: 'suwe-Kosmetik',
			description: 'suwe-Kosmetik Ecommerce',
			type: 'website',
			url: 'https://suwe-kosmetik.de',
			site_name: 'suwe-Kosmetik',
			images: [
				{
					url: '/pwa/logo.png',
					width: '800',
					height: '600',
					alt: 'suwe-Kosmetik',
				},
			],
		},
		twitter: {
			site: '@suwe-Kosmetik',
			creator: '@suwe-Kosmetik',
			card: 'summary',
			title: 'suwe-Kosmetik',
			description: 'suwe-Kosmetik - Naturkosmetik & innovative Wirkstoffe',
			image: 'https://suwe-kosmetik.de/pwa/logo/logo_color_text.png',
		},
		revisit_after: '15 days',
		copyright_year: '2023',
	},
}

export { appConfig }
